export const ru = {
    'high-priority': 'Высокий',
    'low-priority': 'Низкий',
    'medium-priority': 'Средний',
    'replace-validation-error-empty-value-for-phrase':
        'Ключевые фразы не могут быть пусты - введите значение для замены',
    'replace-validation-error-invalid-characters':
        'Минус-слова нужно указывать через пробел, не используя знаки: «-»  и «,».',
    'status-active': 'Активна',
    'status-archived': 'В архиве',
    'status-deleted': 'Удалена',
    'status-draft': 'Черновик',
    'status-reject-by-moderator': 'Отклонена на модерации',
    'status-stopped': 'Остановлена',
    'targeting-status-active': 'Активен',
    'targeting-status-deleted': 'Удален',
    'targeting-status-draft': 'Черновик',
    'targeting-status-reject-by-moderator':
        'Условие показа отклонено на модерации',
    'targeting-status-stopped': 'Остановлен'
};
